import React from 'react'
import PropTypes from 'prop-types'
import { fetchLmsCourses } from '../../actions'

export default class CanvasReview extends React.Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
    let { coursenum } = this.context.store.getState()
    this.context.store.dispatch(fetchLmsCourses(coursenum))
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { coursenum, courseTitle, courseList, canvasCoursenum } =
      this.context.store.getState()
    let canvasCourse
    let canvasName = ''
    let assessmentsLink = `/instructor/activities/${coursenum}/`

    if (courseList && courseList.length !== 0) {
      let canvasCourseMap = courseList.reduce((memo, c) => {
        memo[c.id] = c
        return memo
      }, {})
      canvasCourse = canvasCourseMap[canvasCoursenum]
      canvasName = canvasCourse.name
    }

    return (
      <div className="card-myed">
        <div className="canvas-flex-wrapper">
          <div className="wrapper control-box">
            <h3>5. Review</h3>
            <p>
              {courseTitle} is now connected to{' '}
              <span className="bold-span">{canvasName}</span>.
            </p>
            <p>
              Nagivate to your assessments page in MyEducator and select the
              assessments you would like to include in Canvas.
            </p>
            <p>
              Read our{' '}
              <a
                href="https://myeducator.freshdesk.com/support/solutions/articles/14000069099-how-do-i-link-myeducator-to-instructure-canvas-"
                className="faq-link"
              >
                FAQs
              </a>{' '}
              to learn more.
            </p>
            <p>
              This will automatically create corresponding assessments in
              Canvas. Student grades will be updated in Canvas automatically as
              they are completed in MyEducator.
            </p>
            <div className="canvas-flex-wrapper center">
              <a
                href={assessmentsLink}
                className="btn btn-primary btn-myed btn-primary-myed"
              >
                Choose Assessments
              </a>
            </div>
          </div>
          <div className="canvas-statusmarker-container">
            <img src="/static/instructor/media/canvas-logo-lms.png" />
          </div>
        </div>
      </div>
    )
  }
}
